<template>
	<b-container id="stock-transfer-create" v-if="$can('view-stock-transfer') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Stock Transfer Create</h3>
                <hr>
            </b-container>
        </b-row>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(submit)">
                <b-button size="sm" variant="outline-dark" @click="openModal('excel-paste')">PASTE CSV</b-button>
                <b-button type="submit" size="sm" variant="success">Submit</b-button>
                <b-form-row>
                    <b-col cols="d">
                        <b-form-group
                            id="input-group-date"
                            label="Date:"
                            label-for="input-date"
                            label-size="sm"
                        >
                            <b-form-datepicker
                                id="input-date"
                                v-model="row.date"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                class="mb-2"
                            >
                            </b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="2">
                        <b-form-group
                            id="select-group-from"
                            label="From WH:"
                            label-for="select-from"
                            label-size="sm"
                        >
                            <b-form-select v-model="row.from" :options="locations" @change="renderOptions('from')"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="2">
                        <b-form-group
                            id="select-group-to"
                            label="To WH:"
                            label-for="select-to"
                            label-size="sm"
                        >
                            <b-form-select v-model="row.to" :options="locations" @change="renderOptions('to')"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row v-for="(item, index) in row.items" :key="index" :class="`index-${index}`">
                    <b-col cols="5">
                        <b-form-group
                            id="select-group-sku"
                            label="SKU:"
                            label-for="select-sku"
                            label-size="sm"
                        >
                            <autosuggest-instance
                                :key="index"
                                :idx="index"
                                @nextRow="nextRow"
                                @suggestFirstRow="suggestFirst"
                                @onSelectedRow="onSelected"
                                @focusMeRow="focusMe(index)"
                                :ref="'skuinput' + index"
                            />
                            <!-- <div class="options-assign">
                                <div class="autosuggest-container">
                                    <vue-autosuggest
                                        v-model="row.items[index].sku"
                                        :suggestions="filteredOptions(index)"
                                        @focus="focusMe(index)"
                                        @click="clickHandler"
                                        @input="onInputChange"
                                        @selected="onSelected"
                                        :get-suggestion-value="getSuggestionValue"
                                        :input-props="{id:'autosuggest__input_' + index, placeholder:''}"
                                        @keyup.enter="suggestFirst(index, $event.target.value)"
                                        @item-changed="onItemChanged"
                                >
                                    <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                                        <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.name}}</div>
                                    </div>
                                  </vue-autosuggest>
                                </div>
                            </div> -->
                        </b-form-group>
                    </b-col>
                    <b-col id="qty-col" cols="2">
                        <validation-provider
                          name="QTY"
                          rules="integer"
                          v-slot="validationContext"
                        >
                            <b-form-group
                                :id="'input-group-qty' + index"
                                label="QTY:"
                                label-for="input-qty"
                                label-size="sm"
                            >
                                <b-form-input
                                    :id="'input-qty-' + index"
                                    v-model="row.items[index].qty"
                                    type="text"
                                    placeholder=""
                                    size="sm"
                                    autocomplete="off"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-qty-live-feedback"
                                >
                                </b-form-input>

                                <b-form-invalid-feedback id="input-qty-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols="1">
                        <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
                    </b-col>
                    <b-col cols="1">
                        <b-button type="submit" size="sm" variant="success">Submit</b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </validation-observer>

        <modal-excel-paste v-if="modals['modal-warehousing-stocktransfer-excel-paste'].active"
                @updateRowItems="updateRowItems" />
    </b-container>
</template>

<script>
    import { VueAutosuggest } from "vue-autosuggest"
    import AutosuggestInstance from '../../../user/inventory/products/AutosuggestInstance'
    import { debounce } from 'vue-debounce'
    import ModalExcelPaste from './modals/ExcelPaste'
	export default {
        name: 'StockTransferCreate',

        metaInfo() {
            return {
                title: 'Stock Transfer Create',
            }
        },

        components: {
            VueAutosuggest,
            AutosuggestInstance,
            'modal-excel-paste': ModalExcelPaste
        },

		data() {
            return {
                modals: {
                    'modal-warehousing-stocktransfer-excel-paste': {
                        active: 0
                    }
                },

                row: {
                    date: '',
                    from: 'BSG',
                    to: 'Road',
                    items: []
                },
                locations: [],
                products: [
                    {
                        data: []
                    }
                ],
                query: '',
                selected: '',
                currentIndex: ''
			}
		},

        methods: {
            nextRow(idx, col) {
                let target = col + 'input' + (idx + 1)

                if (col == 'sku') {
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].focus()
                } else {
                    this.$refs[target][0].$el.focus()
                }
            },

            suggestFirst(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed) {
                this.row.items[idx].sku = sku
                this.row.items[idx].suggestions = []
            },

            updateRowItems(rows) {
                this.resetView(rows.length)

                this.$nextTick(() => {
                    rows.forEach((row, idx, array) => {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = row.sku
                        this.$refs['skuinput' + idx][0].query = row.sku
                        this.row.items[idx].sku = row.sku
                        this.row.items[idx].qty = row.qty
                    })
                })
            },

            openModal(modalName, row, area) {
                let prefix = 'modal-warehousing-stocktransfer-'
                switch (modalName) {
                    case 'excel-paste':
                        this.modals[prefix + modalName].active = 1
                        break;
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    this.row.items.push({sku: '', qty: ''})
                }
            },

            renderOptions(area) {
                if (area == 'from') {
                    if (this.row.to == this.row.from) {
                        this.locations.forEach((loc, idx, array) => {
                            if (loc != this.row.from) {
                                this.row.to = this.locations[idx]
                            }
                        })

                    }
                } else {
                    if (this.row.from == this.row.to) {
                        this.locations.forEach((loc, idx, array) => {
                            if (loc != this.row.to) {
                                this.row.from = this.locations[idx]
                            }
                        })

                    }
                }
            },

            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },

            submit() {
                let row = this.row
                let url = 'api/warehousing/stocktransfer/submit'
                axios.post(url, {
                    row
                })
                .then((res) => {
                    this.showAlertBox('success', 'Stock Transfer', 'Stock transfer(s) submitted successfully!')
                    this.resetView(25)
                }, () => {
                    this.has_error = true
                })
            },

            getProducts() {
                let url = 'api/inventory/products/getproductsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.products[0].data = res.data.items
                }, () => {
                    this.has_error = true
                })
            },

            clickHandler(item) {
              // event fired when clicking on the input
            },

            onSelected(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed) {
                this.row.items[idx].sku = sku
                this.row.items[idx].suggestions = []
            },

            onInputChange(text) {
                // console.log(text)
              // event fired when the input changes
              // console.log(text)
            },

            onItemChanged(text) {
                if (text) {
                    this.row.items[this.currentIndex].sku = text.item.name
                }
            },

            getSuggestionValue(suggestion) {
                return suggestion.item.name
            },

            focusMe(index) {
                this.currentIndex = index

                if (this.row.items.length == index + 1) {
                    this.row.items.push({ sku: '', qty: '', suggestions: [] })

                    this.scrollToElement({ behavior: 'smooth' }, index + 1)
                }
            },

            filteredOptions(index) {
                return [
                    {
                        data: this.products[0].data.filter(option => {
                            return option.name.toLowerCase().indexOf(this.row.items[index].sku.toLowerCase()) > -1
                        })
                    }
                ]
            },

            resetView(amount) {
                this.row.date = this.$moment().format('YYYY-MM-DD')

                this.row.items = []

                for (var index = 0; index <= amount; index++) {
                    this.row.items.push({sku: '', qty: ''})
                }

                this.row.from = 'BSG'
                this.row.to = 'Road'
                this.query = ''
                this.selected = ''
                this.currentIndex = ''
            }
		},

        mounted() {
            this.getProducts()

            this.locations = Object.keys(this.getLocations)

            this.resetView(25)

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-warehousing-stocktransfer-excel-paste':
                        this.modals[modalId].active = 0

                        break
                }
            })
        }
	}
</script>

<style lang="scss">
    #stock-transfer-create {
        .vue-treeselect__control {
            font-size: 0.875rem !important;
        }

        #qty-col {
            input {
                // min-width: 56px;
                width: 100%;
            }
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                // min-width: 400px;
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                justify-content: center;
                width: 100%;
            }

            #autosuggest {
                width: 100%;
                display: block;
            }

            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }
        }
    }
</style>
